// Custom scripts.

window.addEventListener('load', () => {
  /*****************************************************************************
   * Update add-on quantity on main product change.
   ****************************************************************************/
  new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const currentClassList = mutation.target.classList;
        if (!currentClassList.contains('is-processing')) {
          const cart = mutation.target;

          // [1] Find the add-ons
          const addons = cart.querySelectorAll('.cart-item--eng-add-on');

          // [2] Loop through the add-ons and check if main product quantity matches
          for (let i = 0; i < addons.length; i++) {
            const addon = addons[i];
            const mainQty = cart.querySelector(
              `[data-bundle-id="${addon.dataset.bundleId}"]:not(.cart-item--eng-add-on) .quantity__input`
            );
            const addonQty = addon.querySelector('.quantity__input');

            // [3] If the main product doesn't exist then remove the add-on
            if (!mainQty) {
              addonQty.value = 0;
              addonQty.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }

            // [4] If the add-on and main product quantities don't match, update the add-on
            if (addonQty.value !== mainQty.value) {
              addonQty.value = mainQty.value;
              addonQty.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      }
    }
  }).observe(document.querySelector('cart-items'), {
    attributes: true,
    attributeFilter: ['class'],
  });

  /*****************************************************************************
   * Offer personalization if available.
   ****************************************************************************/
  const yoEngravingOpener = document.querySelector('.yo-engraving-opener');

  // Assume personalization is available if opener is present.
  if (yoEngravingOpener) {
    // Forever Pets items already includes engraving costs in the pricing.
    /** @type {{ options: string[], vendor: string }} */
    const yoProduct = JSON.parse(document.querySelector('[data-yo-product]').textContent);

    /** @type {HTMLButtonElement} */
    let triggeredAtc;

    /** @type {HTMLElement} */
    const offerModal = document.getElementById('YOOfferEngravingModal').content.firstElementChild;

    // Yes, please
    offerModal.querySelector('.yo-offer-engraving-modal__buttons__yes').addEventListener('click', (event) => {
      offerModal.classList.remove('active');
      document.querySelector('.yo-engraving-opener').click();
    });

    // No, thanks
    offerModal.querySelector('.yo-offer-engraving-modal__buttons__no').addEventListener('click', (event) => {
      offerModal.classList.remove('active');
      triggeredAtc.classList.add('skip-offer-engraving');
      triggeredAtc.click();
    });

    document.body.append(offerModal);

    // Attach event handlers to ATC buttons
    document.querySelectorAll('[name="add"]:not(.yo-engraving__atc)').forEach((el) => {
      el.addEventListener('click', (event) => {
        if (event.currentTarget.classList.contains('skip-offer-engraving'))
          return event.currentTarget.classList.remove('skip-offer-engraving');

        if (yoProduct.vendor === 'Forever Pets') {
          /** @type {{ options: string[] }} */
          const selectedVariant = JSON.parse(document.querySelector('[data-selected-variant]').textContent);

          if (yoProduct.options.includes('Personalization') && selectedVariant.options.includes('Engraving')) {
            document.querySelector('.yo-engraving-opener').click();
            event.preventDefault();
          }
        } else {
          triggeredAtc = event.currentTarget;
          event.preventDefault();
          offerModal.classList.add('active');
        }
      });
    });
  }

  /*****************************************************************************
   * Update main form ATC button label if Engraving
   ****************************************************************************/
  if (Yawidoo.request.pageType === 'product') {
    new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && !mutation.target.disabled) {
          /** @type {{ options: string[] }} */
          const yoProduct = JSON.parse(document.querySelector('[data-yo-product]').textContent);
          
          /** @type {{ available: boolean, options: string[] }} */
          const selectedVariant = JSON.parse(document.querySelector('[data-selected-variant]').textContent);
          
          if (yoProduct.options.includes('Personalization') && selectedVariant.options.includes('Engraving')) {
            mutation.target.querySelector('span').textContent = 'Personalize';
          } else {
            mutation.target.querySelector('span').textContent = selectedVariant.available
            ? window.variantStrings.addToCart
            : window.variantStrings.soldOut;
          }
        }
      }
    }).observe(document.querySelector('.product-form__submit'), { attributes: true });
  }
});
